import React from 'react';
import { Row } from 'reactstrap';
import { observer } from 'mobx-react-lite';
import { createWrapperFieldRenderer } from '../../helpers/createWrapperFieldRenderer';
const Entity = ({
  asLabel,
  data,
  validationkeyValue,
  handleChangeViaObject,
  hasError,
  index
}) => {
  const renderWrapperField = createWrapperFieldRenderer({
    fieldMap: validationkeyValue,
    dataObj: data,
    disabled: asLabel,
    showError: hasError,
    defaultOnChange: handleChangeViaObject
  });
  return <div>
            {renderWrapperField('entities[].relations', {
      key: `entities[].relations-${index}`,
      arrayIndexing: index
    })}

            <Row>
                {renderWrapperField('entities[].name', {
        key: `entities[].name-${index}`,
        arrayIndexing: index,
        className: 'col-sm-6'
      })}

                {renderWrapperField('entities[].incorpCountry', {
        key: `entities[].incorpCountry-${index}`,
        arrayIndexing: index,
        className: 'col-sm-6'
      })}


                {renderWrapperField('entities[].website', {
        key: `entities[].website-${index}`,
        arrayIndexing: index,
        className: 'col-sm-6'
      })}

                {renderWrapperField('entities[].businessNature', {
        key: `entities[].businessNature-${index}`,
        arrayIndexing: index,
        className: 'col-sm-6'
      })}

                {renderWrapperField('entities[].yearOfIncorporation', {
        key: `entities[].yearOfIncorporation-${index}`,
        arrayIndexing: index,
        className: 'col-sm-6'
      })}

                {renderWrapperField('entities[].percentOwner', {
        key: `entities[].percentOwner-${index}`,
        arrayIndexing: index,
        className: 'col-sm-6'
      })}


                {renderWrapperField('entities[].sourceOfWealthList', {
        key: `entities[].sourceOfWealthList-${index}`,
        arrayIndexing: index
      })}


            </Row>


        </div>;
};
export default observer(Entity);
